class ImageUploader {
    apiEndpoint = 'https://storefront-api.panda-weltmaschine.de/custom-image';

    async uploadImageFile(imageFile) {
        try {
            if (!imageFile) {
                throw new Error('No image file found. Please ensure the image was properly selected.');
            }

            const formData = new FormData();
            formData.append('file', imageFile);

            const path = this.apiEndpoint + '/upload-file';

            const response = await fetch(path, {
                method: 'POST',
                body: formData
            });

            this.logMessage('info', 'Image uploaded to ' + path);

            if (!response.ok) {
                if (response.status === 413) {
                    throw new Error('Image file too large. Please choose a smaller file.');
                } else if (response.status >= 400 && response.status < 500) {
                    throw new Error(`Client error: ${response.status} - ${response.statusText}. Please check the image file and try again.`);
                } else if (response.status >= 500) {
                    throw new Error(`Server error: ${response.status} - ${response.statusText}. Please try again later.`);
                } else {
                    throw new Error(`Unknown error: ${response.status} - ${response.statusText}`);
                }
            }

            const result = await response.json();

            if (!result || typeof result.url !== 'string') {
                throw new Error('Invalid response from server: Image URL missing or invalid.');
            }

            return result.url;
        } catch (error) {
            console.error('Error uploading image.', error);
            this.logMessage('error', 'Error uploading image: ' + error.message);
            alert('Error uploading image: ' + error.message);
            return null;
        }
    }

    logMessage(severity, message) {
        const path = this.apiEndpoint + '/frontend-log/';
        fetch(path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ severity, message })
        });
    }
}
